export default {
  SET_LOCALE: '@WS/I18N/SET_LOCALE',
};
